import React, { useEffect, useState } from 'react';
import GetHeaders from '../components/Document/getHeaders';
import fetchJson from './fetchJson';

const ProcessMarkdown = (markdownFile: string) => {
  const [data, setData] = useState([]);
  useEffect(() => {
    (async () => {
      const res: any = await fetchJson(`/api/markdown`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ fileName: markdownFile }),
      });
      setData(res.content);
    })();
  }, []);

  interface IDataObject {
    content: string;
    type: string;
    tag: string;
    info: string;
  }

  const allData: IDataObject[] = [];

  for (let i = 0; i < data.length; i++) {
    const currentObj = data[i];
    let content = '';
    const typeArr = currentObj.type.split('_');
    const lastItem = typeArr[typeArr.length - 1];
    if (lastItem === 'open' && currentObj.tag) {
      i++;
      while (
        i < data.length &&
        data[i].type.split('_')[typeArr.length - 1] !== 'close'
      ) {
        content += data[i].content;
        i++;
      }
      allData.push({
        type: currentObj.tag,
        tag: currentObj.type.split('_')[0],
        info: currentObj.info,
        content: content,
      });
    }
    if (currentObj.tag === 'code' && currentObj.content) {
      allData.push({
        type: currentObj.tag,
        info: currentObj.info,
        tag: currentObj.tag,
        content: currentObj.content,
      });
    }
  }

  const headers = GetHeaders(allData);

  let newData = [];

  for (let i = 0; i < allData.length; i++) {
    let splitContent = allData[i].content.split(/(<hr>)/g);
    for (let j = 0; j < splitContent.length; j++) {
      if (splitContent[j] !== '') {
        let contentObj: any;
        if (splitContent[j] === '<hr>') {
          contentObj = {
            content: splitContent[j],
            type: 'hr',
            tag: 'hr',
          };
          newData.push(contentObj);
        } else {
          contentObj = {
            content: splitContent[j],
            type: allData[i].type,
            tag: allData[i].tag,
            info: allData[i].info,
          };
          newData.push(contentObj);
        }
      }
    }
  }

  return { newData, headers };
};

export default ProcessMarkdown;
